import PropTypes from 'prop-types'

export const REDUCER_KEY = 'signUp'

export const ACTION_TYPES = {
  SIGN_UP_SUBMIT_FORM_PENDING: 'signUp/SUBMIT_FORM/pending',
  SIGN_UP_SUBMIT_FORM_SUCCESS: 'signUp/SUBMIT_FORM/success',
  SIGN_UP_SUBMIT_FORM_ERROR: 'signUp/SUBMIT_FORM/error',
  SIGN_UP_SUBMIT_FORM_RESET: 'signUp/SUBMIT_FORM/reset',
  SIGN_UP_PERSIST_CAMPAIGN: 'signUp/PERSIST_CAMPAIGN',
}

export const productOptions = [
  {
    value: 'Seller finance',
    label: 'signup.product-type.option.seller-financing',
  },
  {
    value: 'Shipment tracker',
    label: 'signup.product-type.option.shipment-tracker',
  },
]

export const SignUpFieldsShape = {
  productType: PropTypes.string,
  fullName: PropTypes.string,
  companyName: PropTypes.string,
  country: PropTypes.string,
  email: PropTypes.string,
  countryCode: PropTypes.string,
  phone: PropTypes.string,
}
